/**
 * Created by anthony on 3/15/14.
 */

var calculationService = angular.module('calculationService', []);
calculationService.factory('CalculationService', function (
    ApplicationService, $location, authServiceFactory, AlertService,
    LivingAllowanceCalcService, SchoolModelService, EditSumsModelService, CheckListService) {
    //Calculation Service
    var reCalc = function()
    {
        EditSumsModelService.resolveData().then(() => {
            var FamCount = ApplicationService.getFamCount();
            ApplicationService.getFamilyData().awardData.reportedIncome = reported_income();
            ApplicationService.getFamilyData().awardData.imputedIncome.totalAssets = total_assets();
            ApplicationService.getFamilyData().awardData.imputedIncome.totalLiabilities  = total_liab();
            ApplicationService.getFamilyData().awardData.imputedIncome.consideredNetWorth= consered_net_worth();
            ApplicationService.getFamilyData().awardData.imputedIncome.imputedNetWorth = imputed_net_worth();
            ApplicationService.getFamilyData().awardData.imputedIncome.imputedIncome = imputed_income();
            LivingAllowanceCalcService.calculate();
            var housing = total_housing();
            ApplicationService.getFamilyData().awardData.housing.threshold = housing.Housing_thresh;
            ApplicationService.getFamilyData().awardData.housing.notConsidered= housing.hou_not_considered;
            ApplicationService.getFamilyData().awardData.housing.housingConsidered = housing.HOU;
            ApplicationService.getFamilyData().awardData.housing.housing = housing.HOUTHR;
            var utilities = total_utilities(); //Remove the following lines by changing the total utilities function
            ApplicationService.getFamilyData().awardData.utilities.threshold = utilities.Utilities_thresh;
            ApplicationService.getFamilyData().awardData.utilities.notConsidered = utilities.utl_not_considered;
            ApplicationService.getFamilyData().awardData.utilities.utilities = utilities.UTLTHR;
            ApplicationService.getFamilyData().awardData.utilities.utilitiesConsidered = utilities.UTL;
            ApplicationService.getFamilyData().awardData.utilities.percentCalc = utilities.utl_percent_calc;

            var insurances = total_insurances();
            ApplicationService.getFamilyData().awardData.insurances.notConsidered= insurances.ins_not_considered;
            ApplicationService.getFamilyData().awardData.insurances.insurancesConsidered = insurances.INS;
            ApplicationService.getFamilyData().awardData.taxes = total_taxes();
            var social_security = total_social_security();
            ApplicationService.getFamilyData().awardData.socialSecurity.a = social_security.SOCa;
            ApplicationService.getFamilyData().awardData.socialSecurity.b = social_security.SOCb;
            ApplicationService.getFamilyData().awardData.socialSecurity.c = social_security.SOCc;
            ApplicationService.getFamilyData().awardData.socialSecurity.d = social_security.SOCd;
            ApplicationService.getFamilyData().awardData.socialSecurity.socialSecurity = social_security.SOC;
            ApplicationService.getFamilyData().awardData.socialSecurity.ssTotalWithholding = Math.round(social_security.SOCa) + Math.round(social_security.SOCb);
            var allowedSavings = total_allowed_savings();
            ApplicationService.getFamilyData().awardData.allowedSavings.allowedSavings = allowedSavings.allowedSavings;
            ApplicationService.getFamilyData().awardData.allowedSavings.allowedSavingsBeforeCap = allowedSavings.allowedSavingsBeforeCap;
            var charity = total_charity();
            ApplicationService.getFamilyData().awardData.charity.threshold = charity.Charity_thresh;
            ApplicationService.getFamilyData().awardData.charity.notConsidered = charity.giv_not_considered;
            ApplicationService.getFamilyData().awardData.charity.charity = charity.GIVTHR;
            ApplicationService.getFamilyData().awardData.charity.charityConsidered = charity.GIV;
            ApplicationService.getAwardData().tuition = ApplicationService.getFamilyData().awardData.tuition = total_tuition();
            ApplicationService.getFamilyData().awardData.calculatedAward.allowedExpenses = total_allowed_expense();

            for (var i = 0; i < FamCount; i++)
            {
                ApplicationService.getFamilyData(i).awardData.calculatedAward.incomeAvailable =
                    available_for_tuition(i);
            }

            calculated_award();
            ApplicationService.getFamilyData().awardData.calculatedAward.calculatedTuition = calculated_tuition();
            //At this point, this logic is only on the front end, it needs to be ported to backend and
            //.family[i].awardData.recommendedAward needs to be populated on server call instead of this call
            calcRecommendedAward();
            CheckListService.init();
        });
    }

    
    var calcRecommendedAward = function()
    {
        var auth = SchoolModelService.get()[0];
        var FamCount = ApplicationService.getFamCount();
        var app = ApplicationService.getAwardData();

        // reset total app award numbers that we need to sum in family calculation
        app.awardData.recommendedAward.incomeAvailable = 0;
        app.awardData.recommendedAward.canPay = 0;

        for (var i = 0 ; i < FamCount; i++)
        {
            var fam = ApplicationService.getFamilyData(i);

            fam.awardData.recommendedAward.totalConsidered = parseInt(app.tuition);
            if (FamCount > 1)
            {
                if (i==0)
                    fam.awardData.recommendedAward.totalConsidered = parseInt(app.tuition)
                        * (fam.thresholds.Thresh_Fam1_Tuition_Percent/100);
                else if (i==1)
                    fam.awardData.recommendedAward.totalConsidered = parseInt(app.tuition)
                        * (fam.thresholds.Thresh_Fam2_Tuition_Percent/100);
            }
            var canPay = parseInt(fam.awardData.recommendedAward.canPay);
            fam.awardData.recommendedAward.canPay = canPay;
            var percCon = fam.awardData.recommendedAward.percentConsidered;
            fam.awardData.recommendedAward.percentConsidered = percCon;

            var amountConsidered = amount_considered(i);
            fam.awardData.recommendedAward.amountConsidered = amountConsidered;
            fam.awardData.recommendedAward.totalAvailable = (canPay > amountConsidered) ? canPay : amountConsidered;

            fam.awardData.recommendedAward.initialNeed = 
                (fam.awardData.recommendedAward.totalConsidered - fam.awardData.recommendedAward.totalAvailable > 0) ?
                fam.awardData.recommendedAward.totalConsidered - fam.awardData.recommendedAward.totalAvailable : 0;

            //calculate recommended award based on initial need and one of three possible rules
            fam.awardData.recommendedAward.recommendedAward = fam.awardData.recommendedAward.initialNeed;
            fam.awardData.recommendedAward.Rule_Used = "Not Applicable";
            if( (auth.Award_Rule_1 == 1) && (auth.Amount_Rule_1 > 0) )
                award_rule_1(fam.awardData.recommendedAward);
            if( (auth.Award_Rule_2 == 1) && (auth.Amount_Rule_2 > 0) )
                award_rule_2(fam.awardData.recommendedAward);
            if( ( auth.Award_Rule_3 == 1) && (auth.Amount_Rule_3 > 0) )
                award_rule_3(fam.awardData.recommendedAward);

            fam.awardData.recommendedAward.POA = 
                fam.awardData.recommendedAward.recommendedAward/fam.awardData.recommendedAward.totalConsidered * 100;

            //add up family calculations for final app calculation
            app.awardData.recommendedAward.incomeAvailable += fam.awardData.recommendedAward.totalAvailable;
            app.awardData.recommendedAward.canPay += canPay;

        }

        //final app calculations
        app.awardData.recommendedAward.ruleUsed = "Not Applicable";
        app.awardData.recommendedAward.initialNeed = 
            parseInt(app.tuition) - app.awardData.recommendedAward.incomeAvailable;
        if (app.awardData.recommendedAward.initialNeed < 0)
            app.awardData.recommendedAward.initialNeed = 0;

        //calculate rec award for total application
        app.awardData.recommendedAward.recommendedAward = app.awardData.recommendedAward.initialNeed;
        if( (auth.Award_Rule_1 == 1) && (auth.Amount_Rule_1 > 0) &&  auth.Amount_Rule_1 > (parseInt(app.tuition)-app.awardData.recommendedAward.recommendedAward)) {
            app.awardData.recommendedAward.recommendedAward = parseInt(app.tuition) - auth.Amount_Rule_1;
            app.awardData.recommendedAward.ruleUsed = "Minimum Tuition";
        }
        if( (auth.Award_Rule_2 == 1) && (auth.Amount_Rule_2 > 0 && (app.awardData.recommendedAward.initialNeed * (auth.Amount_Rule_2*.01)) < app.awardData.recommendedAward.recommendedAward ) ) {
            app.awardData.recommendedAward.recommendedAward = app.awardData.recommendedAward.initialNeed * (auth.Amount_Rule_2*.01);
            app.awardData.recommendedAward.ruleUsed = auth.Amount_Rule_2 + "% of Need";
        }
        if( ( auth.Award_Rule_3 == 1) && (auth.Amount_Rule_3 > 0) &&  parseInt(app.tuition) * auth.Amount_Rule_3*.01 > (parseInt(app.tuition)-app.awardData.recommendedAward.recommendedAward )) {
            app.awardData.recommendedAward.recommendedAward = parseInt(app.tuition) - (parseInt(app.tuition) * auth.Amount_Rule_3*.01);
            app.awardData.recommendedAward.ruleUsed = "Min % of Tuition";
        }
        app.awardData.recommendedAward.percentAward = 
            app.awardData.recommendedAward.recommendedAward/parseInt(app.tuition) * 100;
    }

    var amount_considered = function(i)
    {
        var fac;
        var aft =  available_for_tuition(i);
        var FamCount = ApplicationService.getFamCount();
        if (FamCount > 1)
            fac = Math.round(aft * ApplicationService.getFamilyData(i).thresholds['Thresh_Fam' + (i+ 1) + '_Percent']/100);
        else
            fac = aft;
        return fac;
    }

    //calculate recommendedAward based on 'min tuition' rule per family
    var award_rule_1 = function(recommendedAward)
    {
        var auth = SchoolModelService.get()[0];
        let Rec_Award1 = recommendedAward.totalConsidered - auth.Amount_Rule_1;
        if(Rec_Award1 > 0 && Rec_Award1 < recommendedAward.totalConsidered - recommendedAward.totalAvailable){
            recommendedAward.recommendedAward = Rec_Award1;
            recommendedAward.Rule_Used = "Minimum Tuition";
        }
    }
    //calculate recommendedAward based on '% need' rule per family
    var award_rule_2 = function(recommendedAward)
    {
        var auth = SchoolModelService.get()[0];
        let Rec_Award2 = recommendedAward.initialNeed * (auth.Amount_Rule_2 * .01);
        if(Rec_Award2 > 0 && Rec_Award2 < recommendedAward.recommendedAward){
            recommendedAward.recommendedAward = Rec_Award2;
            recommendedAward.Rule_Used = auth.Amount_Rule_2 + "% of Need";
        }
    }

    //calculate recommendedAward based on 'min % of tuition' rule per family
    var award_rule_3 = function(recommendedAward)
    {
        var auth = SchoolModelService.get()[0];
        let Rec_Award3 = recommendedAward.totalConsidered - (recommendedAward.totalConsidered * auth.Amount_Rule_3*.01);
        if(Rec_Award3 > 0 && Rec_Award3 < recommendedAward.recommendedAward){
            recommendedAward.recommendedAward = Rec_Award3;
            recommendedAward.Rule_Used = "Min % of Tuition";
        }

    }



    var social_security_helper = function(SS_Max, SS_TaxRate, SOC_Med_TaxRate)
    {
        var result = {};
        result.SOCa = ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 * SS_TaxRate;
        result.SOCb = ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 * SS_TaxRate;
        if(result.SOCa>SS_Max){ result.SOCa = SS_Max; }
        if(result.SOCb>SS_Max){ result.SOCb = SS_Max; }
        result.SOCc = ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 * SOC_Med_TaxRate;
        result.SOCd = ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 * SOC_Med_TaxRate;

        result.SOC = result.SOCa + result.SOCb + result.SOCc + result.SOCd;
        return result;

    }
    var canadian_pension_plan_helper = function(SS_Max, SS_TaxRate, SOC_Med_Max, SOC_Med_TaxRate, exemption, SS2_TaxRate = null, SS_Floor = null, SS_Ceiling = null)
    {
        var result = {};
        result.SOCa = (ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 - exemption) * SS_TaxRate;
        result.SOCb = (ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 - exemption) * SS_TaxRate;
        if(result.SOCa>SS_Max){ result.SOCa = SS_Max; }
        if(result.SOCb>SS_Max){ result.SOCb = SS_Max; }
        if(result.SOCa<0){ result.SOCa = 0; }
        if(result.SOCb<0){ result.SOCb = 0; }
        if(ApplicationService.getAwardData().app[0].App_Fin_Year>=2025 && SchoolModelService.get()[0].School_State!="QC") {
            let cpp2 = 0;
            if (ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 > SS_Floor) {
                cpp2 = ((Math.min(ApplicationService.getFamilyData().edit_sums.Inc_Annual_1, SS_Ceiling) - SS_Floor) * SS2_TaxRate);
            }
            else {
                cpp2 = 0;
            }
            result.SOCa += cpp2;

            cpp2 = 0;
            if (ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 > SS_Floor) {
                cpp2 = ((Math.min(ApplicationService.getFamilyData().edit_sums.Inc_Annual_2, SS_Ceiling) - SS_Floor) * SS2_TaxRate);
            }
            else {
                cpp2 = 0;
            }
            result.SOCb += cpp2;
        }

        result.SOCc = ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 * SOC_Med_TaxRate;
        result.SOCd = ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 * SOC_Med_TaxRate;
        if(result.SOCc>SOC_Med_Max){ result.SOCc = SOC_Med_Max; }
        if(result.SOCd>SOC_Med_Max){ result.SOCd = SOC_Med_Max; }

        result.SOC = result.SOCa + result.SOCb + result.SOCc + result.SOCd;
        return result;

    }

    var total_social_security = function()
    {
        var App_Fin_Year = ApplicationService.getAwardData().app[0].App_Fin_Year;
        var schoolCountry = SchoolModelService.get()[0].School_Country;
        var schoolState = SchoolModelService.get()[0].School_State;
        if (schoolCountry=="USA") {
            //Social Security //SOC see http://www1.umn.edu/ohr/payroll/tax/wagelimits/index.html
            if(App_Fin_Year < 2012 && App_Fin_Year > 2008) {
                var SS_Max = 6622;
                var result = social_security_helper(SS_Max, 0.0765, 0);
                if( (result.SOCa + result.SOCb) > SS_Max && App_Fin_Year == 2010){ result.SOC = SS_Max; }
            } 
            else if (App_Fin_Year > 2011 && App_Fin_Year < 2014) {
                var result = social_security_helper(4486, 0.0765, 0);
            } 
            else if (App_Fin_Year > 2013 && App_Fin_Year < 2023) {
                var result = social_security_helper(7961, 0.062, 0.0145);
            }
            else if (App_Fin_Year >= 2023) {
                var result = social_security_helper(9144, 0.062, 0.0145);
            }
        }
        else {
            var exemption = 3500;
            if (schoolState  != "QC")
            {
                var sstaxrate = 0.0495;
                if (App_Fin_Year >= 2025) {
                    // fin year 2025 uses 2024 numbers
                    // CPP2 tier added in 2024
                    var result = canadian_pension_plan_helper(3867.50, 0.0595, 1049.12, 0.0166, exemption, 0.04, 68500, 73200);
                }
                else if (App_Fin_Year >= 2024) {
                    // fin year 2024 uses 2023 numbers
                    var result = canadian_pension_plan_helper(3754.45, 0.0595, 1002.45, 0.0163, exemption);
                }
                else if (App_Fin_Year >= 2023) {
                    // fin year 2023 uses 2022 numbers
                    // starting in 2023 we use the previous year's numbers for this fin year
                    var result = canadian_pension_plan_helper(3499.80, 0.057, 952.74, 0.0158, exemption);
                }
                else if (App_Fin_Year >= 2021) {
                    // did not update in 2022, so this covers both 21 and 22
                    var result = canadian_pension_plan_helper(3166.45, 0.0545, 889.54, 0.0158, exemption);
                }
                else if (App_Fin_Year == 2020) {
                    var result = canadian_pension_plan_helper(2898.00, 0.0525, 856.36, 0.0158, exemption);
                }
                else if (App_Fin_Year == 2019) {
                    var result = canadian_pension_plan_helper(2748.90, 0.051, 860.22, 0.0162, exemption);
                }
                else if (App_Fin_Year == 2018) {
                    var result = canadian_pension_plan_helper(2593.80, sstaxrate, 858.22, 0.0166, exemption);
                }
                else if (App_Fin_Year == 2017) {
                    var result = canadian_pension_plan_helper(2564.10, sstaxrate, 836.19, 0.0163, exemption);
                }
                else if (App_Fin_Year == 2016) {
                    var result = canadian_pension_plan_helper(2544.30, sstaxrate, 955.04, 0.0188, exemption);
                }
                else if (App_Fin_Year == 2015) {
                    var result = canadian_pension_plan_helper(2479.95, sstaxrate, 930.60, 0.0188, exemption);
                }
                else if (App_Fin_Year == 2014) {
                    var result = canadian_pension_plan_helper(2425.5, sstaxrate, 913.68, 0.0188, exemption);
                }
                else if (App_Fin_Year == 2013) {
                    var result = canadian_pension_plan_helper(2356.2, sstaxrate, 891.12, 0.0188, exemption);
                }
                else if (App_Fin_Year == 2012) {
                    var result = canadian_pension_plan_helper(2306.7, sstaxrate, 839.97, 0.0182, exemption);
                }
                else if (App_Fin_Year == 2011) {
                    var result = canadian_pension_plan_helper(2217.6, sstaxrate, 786.76, 0.0173, exemption);
                }
                else if (App_Fin_Year == 2010) {
                    var result = canadian_pension_plan_helper(2163.15, sstaxrate, 747.36, 0.0173, exemption);
                }
                else if (App_Fin_Year == 2009) {
                    var result = canadian_pension_plan_helper(2118.60, sstaxrate, 731.79, 0.0173, exemption);
                }
                else if (App_Fin_Year == 2008)
                {
                    var result = canadian_pension_plan_helper(2049.3, sstaxrate, 711.03, 0.0173, exemption);
                }
            }
            else
            {
                if (App_Fin_Year >= 2025) {
                    // fin year 2025 uses 2024 numbers
                    var result = canadian_pension_plan_helper(4160, 0.064, 834.24, 0.0132, exemption);
                }
                else if (App_Fin_Year >= 2024) {
                    // fin year 2024 uses 2023 numbers
                    var result = canadian_pension_plan_helper(4038.40, 0.064, 781.05, 0.0127, exemption);
                }
                else if (App_Fin_Year >= 2023) {
                    // fin year 2023 uses 2022 numbers
                    // starting in 2023 we use the previous year's numbers for this fin year
                    var result = canadian_pension_plan_helper(3776.10, 0.0615, 723.60, 0.012, exemption);
                }
                else if (App_Fin_Year >= 2021) {
                    // did not update in 2022, so this covers both 21 and 22
                    var result = canadian_pension_plan_helper(3427.90, 0.059, 664.34, 0.0118, exemption);
                }
                else if (App_Fin_Year == 2020) {
                    var result = canadian_pension_plan_helper(3146.40, 0.057, 650.40, 0.012, exemption);
                }
                else if (App_Fin_Year == 2019) {
                    var result = canadian_pension_plan_helper(2991.45, 0.0555, 663.75, 0.0125, exemption);
                }
                else if (App_Fin_Year == 2018) {
                    var result = canadian_pension_plan_helper(2829.60, 0.054, 672.10, 0.013, exemption);
                }
                else if (App_Fin_Year == 2017) {
                    var result = canadian_pension_plan_helper(2797.20, 0.054, 651.51, 0.0127, exemption);
                }
                else if (App_Fin_Year == 2016) {
                    var result = canadian_pension_plan_helper(2737.05, 0.05325, 772.16, 0.0152, exemption);
                }
                else if (App_Fin_Year == 2015) {
                    var result = canadian_pension_plan_helper(2630.25, 0.0525, 762.3, 0.0154, exemption);
                }
                else if (App_Fin_Year == 2014) {
                    var result = canadian_pension_plan_helper(2537.7, 0.05175, 743.58, 0.0153, exemption);
                }
                else if (App_Fin_Year == 2013) {
                    var result = canadian_pension_plan_helper(2427.6, 0.0510, 720.48, 0.0152, exemption);
                }
                else if (App_Fin_Year == 2012) {
                    var result = canadian_pension_plan_helper(2341.65, 0.05025, 674.73, 0.0147, exemption);
                }
                else if (App_Fin_Year == 2011) {
                    var result = canadian_pension_plan_helper(2217.6, 0.0495, 623.22, 0.0141, exemption);
                }
                else if (App_Fin_Year == 2010) {
                    var result = canadian_pension_plan_helper(2163.15, 0.0495, 587.52, 0.0136, exemption);
                }
                else if (App_Fin_Year == 2009) {
                    var result = canadian_pension_plan_helper(2118.60, 0.0495, 583.74, 0.0138, exemption);
                }
                else if (App_Fin_Year == 2008) {
                    var result = canadian_pension_plan_helper(2049.3, 0.0495, 571.29, 0.0139, exemption);
                }
            }
        }

        return result;
    }

    var total_allowed_expense = function()
    {
        var TAA = 0;
        TAA = TAA.addition(ApplicationService.getFamilyData().awardData.livingAllowance.livingAllowance);
        TAA = TAA.addition(ApplicationService.getFamilyData().awardData.housing.housingConsidered);
        TAA = TAA.addition(ApplicationService.getFamilyData().awardData.utilities.utilitiesConsidered);
        TAA = TAA.addition(ApplicationService.getFamilyData().awardData.insurances.insurancesConsidered);
        if (SchoolModelService.get()[0].School_Country=='USA' || SchoolModelService.get()[0].School_Country=='CAN') {
            TAA = TAA.addition(ApplicationService.getFamilyData().awardData.taxes);
            TAA = TAA.addition(ApplicationService.getFamilyData().awardData.socialSecurity.socialSecurity);
        }
        TAA = TAA.addition(ApplicationService.getFamilyData().awardData.allowedSavings.allowedSavings);
        TAA = TAA.addition(ApplicationService.getFamilyData().awardData.charity.charityConsidered);
        return Math.round(TAA);

    }


    var available_for_tuition = function(i)
    {
        var AFT = ApplicationService.getFamilyData(i).awardData.reportedIncome +
            ApplicationService.getAwardData().family[i].awardData.imputedIncome.imputedIncome -
            ApplicationService.getAwardData().family[i].awardData.calculatedAward.allowedExpenses;
        if (AFT < 0)
            AFT = 0;
        return Math.round(AFT);
    }

    var calculated_award = function()
    {
        let auth = SchoolModelService.get()[0];
        let awardData = ApplicationService.getAwardData();
        for (let i = 0; i < ApplicationService.getFamCount(); i++) {
            let FCA = 0;
            if (auth.Award_Pref_2 === 1 && !ApplicationService.isFamilyTwoExcuseSituation() && ApplicationService.getFamCount() > 1) {
                let tuition = 0;
                if (i == 0) {
                    tuition = awardData.tuition * (awardData.family[i].thresholds.Thresh_Fam1_Tuition_Percent * .01);
                } else {
                    tuition = awardData.tuition * (awardData.family[i].thresholds.Thresh_Fam2_Tuition_Percent * .01);
                }
                FCA = tuition - awardData.family[i].awardData.calculatedAward.incomeAvailable;
            } else {
                FCA = awardData.tuition - awardData.family[i].awardData.calculatedAward.incomeAvailable;
            }
            if (FCA < 0) {
                FCA = 0;
            }
            awardData.family[i].awardData.calculatedAward.calculatedAward = Math.round(FCA);
        }
    }

    var calculated_tuition = function()
    {
        var FCT = ApplicationService.getAwardData().tuition - ApplicationService.getFamilyData().awardData.calculatedAward.calculatedAward;
        if (FCT < 0)
            FCT = 0;
        return Math.round(FCT);
    }

    var total_expense = function()
    {
        var t_expense = 0;
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Rea_Mort_Pay);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Rent);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Veh_Payment * 12);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Oth_Mort_Pay);
        t_expense = t_expense.addition(AlertService.getOtherTuition(ApplicationService.getFamilyNo()));
        t_expense = t_expense.addition(AlertService.getColTuition(ApplicationService.getFamilyNo()));
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Home_Ins);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Life_Ins);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Health_Ins);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Auto_Ins);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Elec);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Heat);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Util);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Child_Supp);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Med_Val);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Loan_Val);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Dep_Val);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Alimony);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Charity);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Childcare_Val);
        t_expense = t_expense.addition(ApplicationService.getFamilyData().edit_sums.Exp_Other_Val);
        return Math.round(t_expense);
    }

    var reported_income = function()
    {

        var INC;
        INC = "0";
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Annual_1);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Annual_2);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Business);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Div_Int);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Cap_Gain);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Estate);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Trust);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Child_Supp);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Alimony);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Gifts);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Other);
        INC = INC.subtraction(ApplicationService.getFamilyData().edit_sums.Exp_Child_Supp);
        INC = INC.subtraction(ApplicationService.getFamilyData().edit_sums.Exp_Alimony);
        if (parseInt(INC) < 0)
            INC = "0";

        return Math.round(INC);
    }

    var awardDataTotalLiab = function()
    {
        var TLI;
        TLI = "0";
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Rea_Principle);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Oth_Principle);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Veh_Debt_Out);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Credit);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Equity_Loan);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Personal_Loan);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Other_Val);
        return Math.round(TLI);

    }

    var awardDataTotalIncome = function()
    {
        var INC;
        INC = "0";
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Annual_1);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Annual_2);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Business);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Div_Int);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Cap_Gain);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Estate);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Trust);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Child_Supp);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Alimony);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Gifts);
        INC = INC.addition(ApplicationService.getFamilyData().edit_sums.Inc_Other);
        return Math.round(INC);
    }

    var total_assets = function()
    {
        var TAS;
        TAS = "0";
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Oth_PMV);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Veh_EMV);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Savings);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Checking);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Deposit);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Securities);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Trust_Val);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Bus_Val);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Other_Val);


        if (ApplicationService.getFamilyData().thresholds.Retire != 1)
            TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Ret_Sav);

        if (ApplicationService.getFamilyData().thresholds.Equity != 1)
            TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Rea_PMV);

        return Math.round(TAS);
    }

    var awardDataTotalAssets = function()
    {
        var TAS;
        TAS = "0";
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Oth_PMV);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Veh_EMV);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Savings);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Checking);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Deposit);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Securities);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Trust_Val);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Bus_Val);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Other_Val);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Asset_Ret_Sav);
        TAS = TAS.addition(ApplicationService.getFamilyData().edit_sums.Rea_PMV);


        return Math.round(TAS);
    }

    var total_liab = function()
    {
        var TLI;
        TLI = "0";

        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Oth_Principle);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Veh_Debt_Out);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Credit);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Equity_Loan);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Personal_Loan);
        TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Liab_Other_Val);
        if (ApplicationService.getFamilyData().thresholds.Equity != 1)
            TLI = TLI.addition(ApplicationService.getFamilyData().edit_sums.Rea_Principle);


        return Math.round(TLI);
    }

    var consered_net_worth = function()
    {
        var CNW = ApplicationService.getFamilyData().awardData.imputedIncome.totalAssets - ApplicationService.getFamilyData().awardData.imputedIncome.totalLiabilities;
        if (CNW < 0)
            CNW = 0;
        return Math.round(CNW);
    }

    var imputed_net_worth = function()
    {
        var INW = ApplicationService.getFamilyData().awardData.imputedIncome.consideredNetWorth - ApplicationService.getFamilyData().thresholds.Thresh_Assets_Cap;
        if (INW < 0)
            INW = 0;
        return Math.round(INW);
    }

    var imputed_income = function()
    {
        var IMP = Math.round(ApplicationService.getFamilyData().awardData.imputedIncome.imputedNetWorth * (ApplicationService.getFamilyData().thresholds.Thresh_Assets_Percent/100));
        return Math.round(IMP);

    }

    
    var total_housing = function()
    {
        //Housing
        //Reported Housing, and Housing Amount Not Considered
        var result = {}
        result.HOUTHR = 0;
        result.Housing_thresh = 0;
        result.hou_not_considered = 0;
        result.HOU = 0;
        var HOU_Add = 0;


        var INC = ApplicationService.getFamilyData().awardData.reportedIncome;

        var MOR = ApplicationService.getFamilyData().edit_sums.Rea_Mort_Pay;


        var housing_percent = ApplicationService.getFamilyData().thresholds.Thresh_Housing_Percent;
        var housing_cap = ApplicationService.getFamilyData().thresholds.Thresh_Housing_Cap;
        var hou_percent_calc = Math.round(INC * (housing_percent/100));
        for(var i = 0; i < ApplicationService.getAwardData().family[ApplicationService.getFamilyNo()].real_estate.length; i++)
        {
            if (ApplicationService.getAwardData().family[ApplicationService.getFamilyNo()].real_estate[i].Rea_Description == "Family Home")
            {
                var Rea_Property_Inc = ApplicationService.getAwardData().family[ApplicationService.getFamilyNo()].real_estate[i].Rea_Property_Inc;
                var Rea_Home_Ins = ApplicationService.getAwardData().family[ApplicationService.getFamilyNo()].real_estate[i].Rea_Home_Ins;
            }
        }
        if(Rea_Home_Ins != 1)
            HOU_Add += parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Home_Ins);

        if(Rea_Property_Inc != 1)
            HOU_Add += parseInt(ApplicationService.getFamilyData().edit_sums.Rea_Property_Tax);

        //Other Case 
        /*if ((MOR > 0 || ApplicationService.getFamilyData().edit_sums.Rea_PMV > 0) && ApplicationService.getFamilyData().edit_sums.Exp_Rent !== 0)
            result.HOUTHR = parseInt(MOR) + parseInt(HOU_Add);
        else
            result.HOUTHR = ApplicationService.getFamilyData().edit_sums.Exp_Rent;*/

        if ((parseInt(MOR) + parseInt(HOU_Add)) > 0)
            result.HOUTHR = parseInt(MOR) + parseInt(HOU_Add);
        else
            result.HOUTHR = ApplicationService.getFamilyData().edit_sums.Exp_Rent;

        if (result.HOUTHR < hou_percent_calc  && result.HOUTHR < housing_cap) {
            result.HOU = result.HOUTHR;
            result.hou_not_considered = 0;
            if (housing_cap > hou_percent_calc)
                result.Housing_thresh = hou_percent_calc;
            else
                result.Housing_thresh = housing_cap;
        } else if (
            result.HOUTHR >= hou_percent_calc
            && hou_percent_calc < housing_cap
            && result.HOUTHR >= housing_cap
        ) {
            result.hou_not_considered = result.HOUTHR - hou_percent_calc;
            result.HOU = hou_percent_calc;
            result.Housing_thresh = hou_percent_calc;
        } else if (hou_percent_calc >= housing_cap || result.HOUTHR >= housing_cap) {
            result.HOU = housing_cap;
            result.hou_not_considered = result.HOUTHR - housing_cap;
            result.Housing_thresh = housing_cap;
        } else if (hou_percent_calc < housing_cap && result.HOUTHR < housing_cap) {
            result.HOU = hou_percent_calc;
            result.hou_not_considered = result.HOUTHR - result.HOU;
            result.Housing_thresh = hou_percent_calc;
        } else {
            result.HOU = housing_cap;
            result.hou_not_considered = result.HOUTHR - housing_cap;
            result.Housing_thresh = housing_cap;
        }
        if (result.hou_not_considered < 0)
            result.hou_not_considered = 0;

        //result.HOU = ApplicationService.getFamilyData().edit_sums.Exp_Rent + ApplicationService.getFamilyData().edit_sums.Rea_Property_Tax;

        return result;

    }

    var total_utilities = function()
    {
        //Utilities
        //Houses Utilities Threshold, Amount Not Considered & Utilites Reported
        var result = {}
        result.UTLTHR = 0;
        result.utl_not_considered = 0;
        result.UTL = 0;


        var INC = ApplicationService.getFamilyData().awardData.reportedIncome;
        var utilities_percent = ApplicationService.getFamilyData().thresholds.Thresh_Utilities_Percent;
        var utilities_cap = ApplicationService.getFamilyData().thresholds.Thresh_Utilities_Cap;
        var utl_percent_calc = Math.round(INC * (utilities_percent/100));
        result.utl_percent_calc = utl_percent_calc;


        result.UTLTHR =parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Elec) + parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Heat);
        if (result.UTLTHR < utl_percent_calc  && result.UTLTHR < utilities_cap) {
            result.UTL = result.UTLTHR;
            result.utl_not_considered = 0;
            if (utilities_cap > utl_percent_calc)
                result.Utilities_thresh = utl_percent_calc;
            else
                result.Utilities_thresh = utilities_cap;
        } else if (result.UTLTHR >= utl_percent_calc && utl_percent_calc < utilities_cap && result.UTLTHR > utilities_cap) {
            result.utl_not_considered = result.UTLTHR - utl_percent_calc;
            result.UTL = utl_percent_calc;
            result.Utilities_thresh = utl_percent_calc;
        } else if (utl_percent_calc > utilities_cap || result.UTLTHR >  utilities_cap) {
            result.UTL = utilities_cap;
            result.utl_not_considered = result.UTLTHR - utilities_cap;
            result.Utilities_thresh = utilities_cap;
        } else if (utl_percent_calc < utilities_cap && result.UTLTHR < utilities_cap) {
            result.UTL = utl_percent_calc;
            result.utl_not_considered = result.UTLTHR - result.UTL;
            result.Utilities_thresh = result.UTL;
        } else {
            result.UTL = utilities_cap;
            result.utl_not_considered = result.Utilities_thresh = utilities_cap;
        }


        if (result.utl_not_considered < 0)
            result.utl_not_considered = 0;

        result.introSteps = intro_utilities();
        return result;

    }

    var intro_utilities = function()
    {

        //Intro JS
        var considered = ApplicationService.getFamilyData().awardData.utilities.utilitiesConsidered;
        var electric = ApplicationService.getFamilyData().edit_sums.Exp_Elec;
        var heat = ApplicationService.getFamilyData().edit_sums.Exp_Heat;
        var actual = electric + heat;
        var percent = ApplicationService.getFamilyData().thresholds.Thresh_Utilities_Percent;
        var income = ApplicationService.getFamilyData().awardData.reportedIncome;
        var percentCalc = ApplicationService.getFamilyData().awardData.utilities.percentCalc;
        var cap = ApplicationService.getFamilyData().thresholds.Thresh_Utilities_Cap

        var introSteps = [
            {
                element: document.querySelector("#TotalUtilities"),
                intro: "Wondering how we determined this family's Utilities expense of " +
                    considered +
                    "? Click next to find out how.."
            },
            {
                element: document.querySelector('#ElectricAndHeat'),
                intro: "First we add the numbers reported for electric and heat together. <br> In this case it is: <br >"
                    + electric + " + " + heat + " " + " = " + actual

            },
            {
                element: document.querySelector('#Percentage'),
                intro: "Then we calculate the Utilities expense with respect to their income. Based on your settings we will consider " +
                    percent + "% of their reported income. (" + income + " * " + (percent/100) + ") = " + percentCalc
            },
            {
                element: '#Cap',
                intro: 'Based on your settings, the maximum amount of Utilities you will consider is ' + cap
            },
            {
                element: '#Threshold',
                intro: "So we have three amounts, the actual (" +  actual + "), the percentage of income (" + percentCalc + ")" +
                    "and the cap (" + cap + "). We will consider the smallest of the three amounts ("  +  considered + ")",
                position: 'bottom'
            },
            {
                element: '#NotConsidered',
                intro: 'There was ' + ApplicationService.getFamilyData().awardData.utilities.notConsidered +' not considered from the original amount'
            }
        ]
        return introSteps;
    }

    var total_insurances = function()
    {
        //Insurances
        var result = {}
        result.ins_not_considered = 0;
        result.INS = 0;

        var Health_Ins = parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Health_Ins);
        var Auto_Ins = parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Auto_Ins);
        var Life_Ins = parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Life_Ins);




        result.INS =parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Life_Ins) +
            parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Auto_Ins) + parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Health_Ins);


        var insurances_cap = parseInt(ApplicationService.getFamilyData().thresholds.Thresh_Insurances_Cap);
        var insurances_cap_a = parseInt(ApplicationService.getFamilyData().thresholds.Thresh_Insurances_Cap_A);
        var insurances_cap_l = parseInt(ApplicationService.getFamilyData().thresholds.Thresh_Insurances_Cap_L);




        if(ApplicationService.getAwardData().app[0].App_Fin_Year > 2008)
        {

            if(Auto_Ins > insurances_cap_a) {
                result.ins_not_considered += Auto_Ins - insurances_cap_a;
                Auto_Ins = insurances_cap_a;
            }


            if(Life_Ins > insurances_cap_l){
                result.ins_not_considered += (Life_Ins - insurances_cap_l);
                Life_Ins = insurances_cap_l;
            }

            result.INS = Health_Ins + Auto_Ins + Life_Ins;
        }
        else if  (result.INS > insurances_cap)
        {
            result.INS = insurances_cap;
            result.ins_not_considered = result.INS - insurances_cap;
        }
        return result;
    }

    var total_taxes = function()
    {
        //Taxes
        let TAX = 0;
        let family = ApplicationService.getFamilyData();
        let state_tax = family.expense.Exp_State_Tax;
        let fed_tax = family.expense.Exp_Fed_Tax;
        let state_tax_file = family.expense.Exp_State_Tax_No;
        let fed_tax_file = family.expense.Exp_Fed_Tax_No;
        let edit_state_tax = family.edit_sums.Tax_State;
        let edit_fed_tax = family.edit_sums.Tax_Fed;
        let tax_state = ApplicationService.getFamilyNo() == 1 ? ApplicationService.getAwardData().app[0].Tax_State_F2 : ApplicationService.getAwardData().app[0].Tax_State;
        if (getTaxEstimated() == 1) {
            TAX = ApplicationService.getFamilyData().edit_sums.Taxes;
        } else {
            if (edit_state_tax != state_tax || edit_fed_tax != fed_tax) {
                // school made edits - take edits
                TAX = edit_state_tax + edit_fed_tax;
            } else {
                if (tax_state == 1 || tax_state == 2) {
                    // verified and no edits - take verified numbers
                    TAX = edit_state_tax + edit_fed_tax;
                } else {
                    // not verified, no edits, not taking estimated taxes - take family reported numbers
                    TAX = state_tax + fed_tax;
                }
            }
        }

        return TAX;
    }

    var getTaxEstimated = function()
    {
        var family = ApplicationService.getFamilyData();
        //Need to make as a service


        var state_tax = family.expense.Exp_State_Tax;
        var fed_tax = family.expense.Exp_Fed_Tax;

        var state_tax_file = family.expense.Exp_State_Tax_No;
        var fed_tax_file = family.expense.Exp_Fed_Tax_No;

        var edit_state_tax = family.edit_sums.Tax_State;
        var edit_fed_tax = family.edit_sums.Tax_Fed;

        var esti = 1;
        if (state_tax == edit_state_tax && fed_tax == edit_fed_tax && (state_tax_file == 1 || fed_tax_file == 1)) {
            esti = 1;
        } else {
            esti = 0;
        }

        if (ApplicationService.getFamilyNo() == 1)
            var tax_state = ApplicationService.getAwardData().app[0].Tax_State_F2;
        else
            var tax_state = ApplicationService.getAwardData().app[0].Tax_State;

        if (tax_state == "1" || tax_state == "2")
            esti = 0;
        return esti;
    }

    var total_allowed_savings = function()
    {
        //Allowed Savings
        var allowed_savings = {};
        var Thresh_Savings_Allowed_Cap = ApplicationService.getFamilyData().thresholds.Thresh_Savings_Allowed_Cap;
        allowed_savings.allowedSavingsBeforeCap  = Math.round(ApplicationService.getFamilyData().awardData.reportedIncome * ApplicationService.getFamilyData().thresholds.Thresh_Savings_Allowed_Percent/100);
        if (allowed_savings.allowedSavingsBeforeCap > Thresh_Savings_Allowed_Cap && Thresh_Savings_Allowed_Cap != 0)
            allowed_savings.allowedSavings = Thresh_Savings_Allowed_Cap;
        else
            allowed_savings.allowedSavings = allowed_savings.allowedSavingsBeforeCap;
        return allowed_savings;
    }
    
    var total_charity = function()
    {
        //Charity
        var result = {}
        result.GIVTHR = 0;
        result.GIV = 0;
        result.Charity_thresh = 0;
        result.giv_not_considered = 0;


        var INC = ApplicationService.getFamilyData().awardData.reportedIncome;
        var charity_percent = ApplicationService.getFamilyData().thresholds.Thresh_Charity_Percent;
        var charity_cap = ApplicationService.getFamilyData().thresholds.Thresh_Charity_Cap;
        var giv_percent_calc = Math.round(INC * (charity_percent/100));

        result.Charity_thresh = giv_percent_calc;
        result.GIVTHR = parseInt(ApplicationService.getFamilyData().edit_sums.Exp_Charity);

        if (result.GIVTHR < giv_percent_calc && ( result.GIVTHR < charity_cap ||  charity_cap == 0) ) {
            result.GIV = result.GIVTHR;
            result.giv_not_considered = 0;
        } else if (
            result.GIVTHR >= giv_percent_calc
            && (result.GIVTHR < charity_cap || charity_cap == 0)
            && result.GIVTHR > charity_cap
        ) {
            result.giv_not_considered = result.GIVTHR - giv_percent_calc;
            result.GIV = giv_percent_calc;
            result.Charity_thresh = giv_percent_calc;
        } else if ( (giv_percent_calc > charity_cap || result.GIVTHR >  charity_cap ) && charity_cap != 0 ) {
            result.GIV = charity_cap;
            result.giv_not_considered = result.GIVTHR - charity_cap;
            result.Charity_thresh = charity_cap;
        } else if (giv_percent_calc < charity_cap && result.GIVTHR <= charity_cap) {
            result.GIV = giv_percent_calc;
            result.giv_not_considered = 0;
            result.Charity_thresh = result.GIVTHR;
        } else if (giv_percent_calc < result.GIVTHR && charity_cap == 0) {
            result.GIV = giv_percent_calc;
            result.giv_not_considered = result.GIVTHR - giv_percent_calc;
            result.Charity_thresh = giv_percent_calc;
        } else {
            result.GIV = charity_cap;
            result.giv_not_considered = result.GIVTHR - charity_cap;
            result.Charity_thresh = charity_cap;
        }
        return result;
    }

    var total_tuition = function()
    {
        var TUI = 0;
        for(var t=0; t < ApplicationService.getAwardData().applicants.length; t++) {
            TUI += parseInt(ApplicationService.getAwardData().applicants[t].App_Tuition);
        }
        return Math.round(TUI);
    }
    //End Calculation Service




    return {
        reCalc: reCalc,
        getTaxEstimated: getTaxEstimated,
        getTotalIncome: reported_income,
        getTotalExpenses: total_expense,
        getTotalAssets: total_assets,
        getTotalLiabilities: total_liab,
        calcRecommendedAward : calcRecommendedAward,
        intro_utilities: intro_utilities,
        awardDataTotalAssets: awardDataTotalAssets,
        awardDataTotalIncome: awardDataTotalIncome,
        awardDataTotalLiab: awardDataTotalLiab
    }
});
/* End binService Service */
